export const compareAmounts = (amount1, operation, amount2) => {
    let compareTrue = false;
    amount1 = +amount1;
    amount2 = +amount2;
    switch (operation){
        case "EQ":
            if (amount1 === amount2){
                compareTrue = true
            }
            break;
        case "GE":
            if (amount2 >= amount1){
                compareTrue = true;
            }
            break;
        case "GT":
            if (amount2 > amount1){
                compareTrue = true;
            }
            break;
        case "LE":
            if (amount2 <= amount1){
                compareTrue = true;
            }
            break;
        case "LT":
            if (amount2 < amount1){
                compareTrue = true;
            }
            break;
        case "NQ":
            if (amount2 !== amount1){
                compareTrue = true;
            }
            break;
        default:
            break;
    }
    return compareTrue;
}
export default compareAmounts;